import { connect } from 'react-redux';
import type { IRegulatoryRejection } from 'state/regulatoryDocuments';
import { getIsUserInternal, getStaticFormInfos } from 'state/selectors';
import { getTradeInfosByWorkspaceTab } from 'state/selectors/common/temp';
import type { AppState } from 'state/state.model';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

export interface OwnProps {
  tabId: string;
  workspaceType: QuoteWorkspaceType;
}

export interface StateProps {
  productSubtype?: string;
  rejections: readonly IRegulatoryRejection[];

  useRejectionCode: boolean;

  hasTimeout: boolean;
}

export type TradeAuthorizationErrorsProps = StateProps & OwnProps;

const mapStateToProps = (state: AppState, { tabId, workspaceType }: OwnProps): StateProps => {
  const infos = getTradeInfosByWorkspaceTab(state, workspaceType, tabId);
  const rejections = infos?.tradeAuthRejections ?? [];
  const isInternal = getIsUserInternal(state);
  const productSubtype = workspaceType === 'static' ? getStaticFormInfos(state, tabId)?.productDescription : undefined;

  const useRejectionCode = !isInternal && workspaceType === 'static';

  return {
    rejections,
    productSubtype,
    useRejectionCode,
    hasTimeout: infos?.tradeAuthStatus === 'Timeout',
  };
};
export const connectTradeAuthorizationErrors = connect(mapStateToProps);
